// eslint-disable-next-line require-jsdoc
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// IDS Components
import Dropdown, { MenuItem } from '@ids-ts/dropdown';
import Radio, { RadioGroup } from '@ids/radio';
import { Modal, ModalContent } from '@ids/modal-dialog';
import Button from '@ids/button';
import { useDispatch } from 'react-redux';
import Loader from '../../Common/Loader';
import TaxFormPartsChart from '../../../../assets/images/IM/Product Category/Tax_Forms_parts_chart_2022.jpg';
import {
  ReduxEvent,
  StateTax,
  taxFormUnavailableMessage,
} from '../../../../assets/pagedata/constant';
import { addToCart } from '../../../services/productDataService';
import '../../../../stylesheets/perfAddToCartPricingSection.scss';
import {
  getCurrentFisicalYear,
  isTaxFormUnavailable,
  taxFormsNextAvlDate,
  isProductOutOfStock,
  currencyFormatter,
} from '../../Util/CommonUtils';
// Third party

const AssistedPayroll = 'Assisted Payroll';
const StndEnhcPayroll = 'Standard or Enhanced Payroll';

// eslint-disable-next-line require-jsdoc
export const PerfAddToCartPricingSection = (props) => {
  const { loading, error, pricing, pricingInformation, product, outOfStockItems = [] } = props;
  const [qbVersion, setQbVersion] = useState(null);
  const [payrollVersion, setPayrollVersion] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedQuantity, setSelectedQuantity] = useState(null);
  const [openModal, setOpenModel] = useState(false);
  const [cityIncomeTax, setCityIncomeTax] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [isErrorMsgDisplay, setError] = useState(false);
  const [outOfStockSkus, setOutOfStockSkus] = useState(null);
  const [outOfStockSingleSku, setOutOfStockSingleSku] = useState(null);

  const dispatch = useDispatch();

  const displayCityIncomeTax = () => {
    return (
      selectedState &&
      payrollVersion === StndEnhcPayroll &&
      StateTax.find((x) => x.StateCode === selectedState).Ask_w2_question_yn
    );
  };

  const getPrices = (payrollVer, state, fileCityTax) => {
    let prices = [];

    if (payrollVer === StndEnhcPayroll) {
      const stTax = StateTax.find((x) => x.StateCode === state);
      const variant = pricingInformation.Variants.find(
        (x) => x.QuickBooksVersion === qbVersion,
      ).PayrollVersions.find((x) => x.Version === payrollVer);
      if (stTax.Ask_w2_question_yn && (fileCityTax === 2 || fileCityTax === 3)) {
        prices = pricing.filter(
          (x) =>
            x.Part.indexOf(stTax.PartsFileCityIncomeTax_W2_Yes.toString()) === 0 &&
            x.Sku.indexOf(variant.Sku) === 0,
        );
      } else if (stTax.Ask_w2_question_yn && fileCityTax === 1) {
        prices = pricing.filter(
          (x) =>
            x.Part.indexOf(stTax.PartsFileCityIncomeTax_W2_No.toString()) === 0 &&
            x.Sku.indexOf('2766') === 0,
        );
      } else {
        prices = pricing.filter((x) => x.Part === variant.Part);
      }
    } else {
      const variant = pricingInformation.Variants.find(
        (x) => x.QuickBooksVersion === qbVersion,
      ).PayrollVersions.find((x) => x.Version === payrollVer);

      prices = pricing.filter((x) => x.Part === variant.Part && x.Sku.indexOf(variant.Sku) === 0);
    }

    return prices;
  };

  const resetOutOfStock = () => {
    setOutOfStockSkus(null);
    setOutOfStockSingleSku(null);
  };

  const handleOutOfStock = (priceList) => {
    if (priceList && priceList.length > 0) {
      const outOfStockList = priceList.filter((eachsku) => eachsku.OutOfStock);
      if (priceList.length === outOfStockList.length) {
        const outOfStockStatus = isProductOutOfStock(
          {
            pfid: null,
            sku: `${priceList[0].Sku}`,
          },
          outOfStockItems,
        );
        setOutOfStockSkus(outOfStockStatus);
      } else {
        setOutOfStockSkus(null);
      }
    }
  };

  const handleSingleSkuOutOfStock = (sku) => {
    if ( sku && sku.length > 0) {
      const outOfStockStatusSku = isProductOutOfStock(
        {
          pfid: null,
          sku,
        },
        outOfStockItems,
      );
      setOutOfStockSingleSku(outOfStockStatusSku);
    }
  };

  const updatedSelectedQuantity = (prdPrices) => {
    const defaultSku = prdPrices.find((x) => x.Quantity === '25')?.Sku;
    if (prdPrices.length > 0) {
      setSelectedQuantity(defaultSku);
      handleSingleSkuOutOfStock(defaultSku);
    } else {
      setSelectedQuantity(null);
    }
  };

  const handleStateChange = (e) => {
    const { value } = e.target;
    setSelectedState(value);
    const priceArr = getPrices(payrollVersion, value, cityIncomeTax);
    handleOutOfStock(priceArr);
    updatedSelectedQuantity(priceArr);
  };

  const onPayrollVerChange = (e) => {
    resetOutOfStock();
    const { value } = e.target;
    setPayrollVersion(value);
    const pvDt = pricingInformation.Variants.find(
      (x) => x.QuickBooksVersion === qbVersion,
    ).PayrollVersions.find((x) => x.Version === e.target.value);

    if (value === AssistedPayroll) {
      const priceArr = getPrices(value, selectedState, cityIncomeTax);
      updatedSelectedQuantity(priceArr);
    } else {
      updatedSelectedQuantity([]);
    }
    setSelectedState(null);
    props.callback(pvDt);
  };

  const handleModalOpen = () => {
    setOpenModel(true);
  };

  const handleModalClose = () => {
    setOpenModel(false);
  };

  const addToCartSuccess = (pageInfo) => {
    props.logToIMWebLogger(
      'info',
      `ProductPage -> PerfAddToCartPricingSection: onAddToCartClicked success`,
    );
    dispatch({
      type: ReduxEvent.PAGE_DATA,
      data: {
        pageData: {
          cartCount: pageInfo.CartCount,
          login: pageInfo.login,
          promotionMessage: pageInfo.PromotionMessage,
        },
      },
    });
    setShowLoader(false);
    props.history.push('/cart');
  };

  const addToCartFailed = (err) => {
    props.logToIMWebLogger(
      'error',
      `ProductPage -> PerfAddToCartPricingSection: onAddToCartClicked failed. Reason: ${err}`,
    );

    props.displayToast('Some error occured. Please try again.');
    setShowLoader(false);
  };

  const onAddToCartClicked = () => {
    setShowLoader(true);
    props.logToIMWebLogger(
      'info',
      `ProductPage -> PerfAddToCartPricingSection: onAddToCartClicked called`,
    );

    if (!selectedQuantity) {
      setError(true);
      setShowLoader(false);
      return;
    }

    const params = {
      IsCustomizable: '0',
      PfId: product.PFID,
      SKU: selectedQuantity,
    };

    addToCart(params, addToCartSuccess, addToCartFailed);
  };

  const onStateTaxRadioChanged = (e) => {
    const { value } = e.target;
    setCityIncomeTax(value);
    const priceArr = getPrices(payrollVersion, selectedState, value);
    handleOutOfStock(priceArr);
    updatedSelectedQuantity(priceArr);
  };

  const showPrices = () => {
    if (payrollVersion === AssistedPayroll) {
      return qbVersion && payrollVersion;
    }
    return qbVersion && payrollVersion && selectedState;
  };

  const getPlaceHolder = (msg) => {
    return loading ? 'Loading....' : error ? 'Error' : msg || 'Select Value';
  };

  const findPayrollVersion = () => {
    window.open(
      'http://payroll.intuit.com/support/?ncid=WCN_PRL_PS|PS',
      'poppayroll',
      'top=0,left=0,height=800,width=1000,toolbar=0,location=0,directories=0,status=0,menubar=0,resizable=1,scrollbars=1',
    );
  };

  const handleQuickBookVersionChange = (e) => {
    setQbVersion(e.target.value);
    setPayrollVersion(null);
    setSelectedQuantity(null);
    setSelectedState(null);
    resetOutOfStock();
    props.callback(null);
  };
  const handleQuantityChange = (e) => {
    setSelectedQuantity(e.target.value);
    handleSingleSkuOutOfStock(e.target.value);
  };

  return (
    <div className="perfAddToCartPricingSection-container">
      <div className="row">
        <div className="col-lg-5 col-sm-12">
          <Dropdown
            label="QuickBooks Version"
            theme="quickbooks"
            buttonType="secondaryGhost"
            placeholder={getPlaceHolder('Select QuickBooks Version')}
            onChange={(e) => {
              handleQuickBookVersionChange(e);
            }}
            value={qbVersion}
            className="margin-bottom-10 product_list_dropdown dropdown-background-color-white-label"
            width="inherit"
            warningText={!qbVersion && isErrorMsgDisplay ? 'Please select a value.' : ''}
          >
            {pricingInformation.Variants.map((p, key) => {
              return (
                <MenuItem
                  key={`${key}`}
                  value={`${p.QuickBooksVersion}`}
                >{`${p.QuickBooksVersion}`}</MenuItem>
              );
            })}
          </Dropdown>
        </div>
        <div className="col-lg-1 col-sm-12" />
        <div className="col-lg-5 col-sm-12">
          <Dropdown
            label="Payroll Version"
            theme="quickbooks"
            buttonType="secondaryGhost"
            placeholder={getPlaceHolder('Select Payroll Version')}
            onChange={onPayrollVerChange}
            value={payrollVersion}
            className="margin-bottom-10 product_list_dropdown dropdown-background-color-white-label"
            width="inherit"
            warningText={!payrollVersion && isErrorMsgDisplay ? 'Please select a value.' : ''}
          >
            {qbVersion ? (
              pricingInformation.Variants.find(
                (x) => x.QuickBooksVersion === qbVersion,
              ).PayrollVersions.map((p, key) => {
                return <MenuItem key={`${key}`} value={`${p.Version}`}>{`${p.Version}`}</MenuItem>;
              })
            ) : (
              <MenuItem disabled value="0">
                Select Payroll Version
              </MenuItem>
            )}
          </Dropdown>
          <p
            onClick={findPayrollVersion}
            onKeyDown={findPayrollVersion}
            className="lnk-view-lg-img p2-regular margin-bottom-20"
            style={{ cursor: 'pointer' }}
          >
            How do I find my payroll version?
          </p>
        </div>
      </div>
      <div className="row">
        {payrollVersion !== AssistedPayroll && (
          <>
            <div className="col-lg-5 col-sm-12">
              <Dropdown
                label="Select state you’re filing in"
                theme="quickbooks"
                buttonType="secondaryGhost"
                placeholder={getPlaceHolder('Select State')}
                onChange={handleStateChange}
                value={selectedState}
                className="margin-bottom-10 product_list_dropdown dropdown-background-color-white-label"
                width="inherit"
                // errorText={fetchError ? 'Unable to fetch the value.' : null}
                warningText={!selectedState && isErrorMsgDisplay ? 'Please select a value.' : ''}
              >
                {StateTax.map((s, key) => {
                  return (
                    <MenuItem key={`${key}`} value={`${s.StateCode}`}>{`${s.StateCode}`}</MenuItem>
                  );
                })}
              </Dropdown>

              <p className="dropdown-helper-text margin-bottom-20">
                We will select the correct number of parts based on the state you select.{' '}
                <span
                  role="button"
                  tabIndex={0}
                  className="lnk-view-lg-img"
                  style={{ cursor: 'pointer' }}
                  onClick={handleModalOpen}
                  onKeyDown={handleModalOpen}
                >
                  See list of parts required for each state.
                </span>
              </p>
            </div>
            <div className="col-lg-1 col-sm-12" />
          </>
        )}
        {!outOfStockSkus?.displayOutOfStock && (
          <div className="col-lg-5 col-sm-12">
            <Dropdown
              label="Quantity"
              theme="quickbooks"
              buttonType="secondaryGhost"
              placeholder={getPlaceHolder(
                payrollVersion !== AssistedPayroll ? 'Select a state for pricing' : 'Select price',
              )}
              onChange={(e) => handleQuantityChange(e)}
              value={selectedQuantity}
              className="margin-bottom-10 product_list_dropdown dropdown-background-color-white-label"
              width="inherit"
              // errorText={error ? 'Unable to fetch the value.' : null}
              warningText={!selectedQuantity && isErrorMsgDisplay ? 'Please select a value.' : ''}
            >
              {showPrices() ? (
                getPrices(payrollVersion, selectedState, cityIncomeTax).map((q, key) => {
                  return (
                    <MenuItem key={`${key}`} value={`${q.Sku}`}>{`${q.Quantity} for ${
                      q.DiscPrice ? currencyFormatter(q.DiscPrice) : currencyFormatter(q.ListPrice)
                    }`}</MenuItem>
                  );
                })
              ) : (
                <MenuItem disabled value="0">
                  {payrollVersion !== AssistedPayroll
                    ? 'Select a state for pricing'
                    : 'Select price'}
                </MenuItem>
              )}
            </Dropdown>
            <p className="dropdown-helper-text margin-bottom-20">
              Quantity will depend on the number of employees you have.
            </p>
          </div>
        )}
      </div>
      {payrollVersion !== AssistedPayroll && (
        <div>
          {displayCityIncomeTax() && (
            <RadioGroup
              theme="quickbooks"
              name="test"
              value={cityIncomeTax}
              label="Are you required to file City Income Tax?"
              onChange={onStateTaxRadioChanged}
              className="product_list_radio_btn_grp"
            >
              <Radio value={1}>No</Radio>
              <Radio value={2}>Yes</Radio>
              <Radio value={3}>I don&#39;t know. Please select for me.</Radio>
            </RadioGroup>
          )}
        </div>
      )}
      {isTaxFormUnavailable() ? (
        <span className="tax-form-unavailable-msg">{`${getCurrentFisicalYear()} ${taxFormUnavailableMessage} ${taxFormsNextAvlDate()}`}</span>
      ) : outOfStockSkus?.displayOutOfStock ? (
        <div className="product-unavailable-msg margin-bottom-20">
          {outOfStockSkus.outOfStockMessage}
        </div>
      ) : outOfStockSingleSku?.displayOutOfStock ? (
        <div className="product-unavailable-msg margin-bottom-20">
          {outOfStockSingleSku.outOfStockMessage}
        </div>
      ) : (
        <Button
          theme="intuit"
          className="margin-bottom-20 pricing-btn perf-tax-pricing-btn"
          // disabled={isButtonDisabled()}
          styleOverrideReason="none"
          onClick={onAddToCartClicked}
          data-wa-link="Add to cart"
          data-ui-object="button"
          data-refer-ui-access-point={`add_to_cart| ${props.contentVariable.toLowerCase()}`}
        >
          Add to cart
        </Button>
      )}
      <Modal
        dismissible
        onClose={() => {
          handleModalClose();
        }}
        className="image-modal"
        open={openModal}
      >
        <ModalContent alignment="center">
          <div>
            <img alt="..." src={TaxFormPartsChart} />
          </div>
        </ModalContent>
      </Modal>
      <Loader show={showLoader} size={80} loadingText="Please wait.." />
    </div>
  );
};

PerfAddToCartPricingSection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  pageData: PropTypes.object.isRequired,
};
